import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth/lib/types';
import { RETURN_PATH_QUERY_PARAM } from '@modules/common/constants';
import { INVITE_CODE_QUERY_PARAM } from '@modules/users/constants';
import { AmplifyAuth } from 'v2/core/clients/authAmplify';
import { checkRedirectURL } from './checkRedirectURL';

export const federatedSignInWithRedirect = async () => {
  const allSearchParams = new URLSearchParams(
    window.location.search.replace('?', ''),
  );

  const {
    [`${RETURN_PATH_QUERY_PARAM}`]: returnTo,
    [`${INVITE_CODE_QUERY_PARAM}`]: inviteCode,
    ...rest
  } = Object.fromEntries(allSearchParams);

  if (inviteCode) {
    const queryString = new URLSearchParams({
      [`${INVITE_CODE_QUERY_PARAM}`]: inviteCode,
    }).toString();

    return AmplifyAuth.federatedSignIn({
      provider: CognitoHostedUIIdentityProvider.Google,
      customState: `${decodeURIComponent(`${inviteCode}`)}${
        queryString ? `?${queryString}` : ''
      }`,
    });
  }

  if (
    !returnTo ||
    checkRedirectURL(typeof returnTo === 'string' ? returnTo : returnTo[0]) ||
    returnTo.includes('logout')
  ) {
    return AmplifyAuth.federatedSignIn({
      provider: CognitoHostedUIIdentityProvider.Google,
    });
  }

  const queryString = new URLSearchParams(rest).toString();

  return AmplifyAuth.federatedSignIn({
    provider: CognitoHostedUIIdentityProvider.Google,
    customState: `${decodeURIComponent(`${returnTo}`)}${
      queryString ? `?${queryString}` : ''
    }`,
  });
};
